export class MdtSelectionStore {
  /** @ngInject */
  constructor() {
    this._byKey = Object.create(null);
  }

  set(key, ids = []) {
    const dict = Object.create(null);
    ids.forEach(id => {
      dict[String(id)] = true;
    });
    this._byKey[key] = dict;
  }

  has(key, id) {
    const dict = this._byKey[key];
    return Boolean(dict && dict[String(id)]);
  }

  clear(key) {
    delete this._byKey[key];
  }
}
